/**
 * SAIT-110. Общая блокировка прокрутки страницы под панелями поверх сайта
 * (выпадающий поиск, мобильное меню): класс tas-overlay-lock на body, правило
 * — в template_styles.css. Панели считаются: каждая снимает только свою
 * блокировку, поэтому закрытие одной не возвращает прокрутку, пока открыта
 * другая. Раньше каждая панель писала в body сама и могла затереть чужое.
 */
let lockCount = 0;

/** поставить блокировку; возвращает функцию, которая снимает именно её */
export function acquireOverlayBodyLock() {
    lockCount += 1;
    document.body.classList.add('tas-overlay-lock');
    let released = false;
    return () => {
        if (released) {
            return;
        }
        released = true;
        lockCount = Math.max(0, lockCount - 1);
        if (lockCount === 0) {
            document.body.classList.remove('tas-overlay-lock');
        }
    };
}
